module.exports = __webpack_public_path__ + "static/img/reservation_hover.6502dd3f.svg";